module.exports = __webpack_public_path__ + "img/banner_new_6.6c5f9b66.png";